import axios from "axios";
import { useQuery } from "react-query";
import { getStoredToken } from "utils/authToken";

const useGetLoggedInUser = () => {
  const { data, isLoading, error, refetch } = useQuery(
    ["getLoggedInUser"],
    async () => {
      try {
        // Always send stored token so auth works when cross-origin cookies are blocked
        const token = getStoredToken();
        const headers = {};
        if (token) {
          headers.Authorization = `Bearer ${token}`;
        }
        const response = await axios.get("auth/getauthsCompany", {
          withCredentials: true,
          headers,
        });

        // Treat false, null, or empty body as "not authenticated" without throwing (avoids console noise)
        const body = response?.data;
        if (body === false || body === null || body === '') {
          return { ...response, data: null };
        }

        return response;
      } catch (err) {
        // Network/server error: return a response that means "not authenticated"
        return { data: null, status: err?.response?.status || 0 };
      }
    },
    {
      staleTime: 5 * 60 * 1000, // 5 minutes - data is considered fresh for 5 minutes
      cacheTime: 10 * 60 * 1000, // 10 minutes - keep in cache for 10 minutes
      refetchOnMount: 'always', // Always refetch on mount, but staleTime prevents if data is fresh
      refetchOnWindowFocus: false, // Don't refetch when window gains focus
      retry: false, // Don't retry on auth failure (response is treated as "not logged in")
    }
  );
  return { data, isLoading, error, refetch };
};

export default useGetLoggedInUser;


